import type {MembershipApiModel} from '../../../api/membership';
import type {Entity} from '../../../api/types';

import {getEntityTypeById} from '../getEntityType';

export function isMembership(entity: Entity): entity is MembershipApiModel {
  const type = getEntityTypeById(entity._id);

  return type === 'membership';
}
